
import React, { useContext, useEffect, useRef, useState } from 'react';
import { withTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LS_AUTHORITY_KEY, currentYear } from "../../../../core/constants/common";
import ReportingUtils from '../../../../core/utilities/ReportingUtils';
import FloatingActionBarForReport from '../FloatingActionBarForReport';
import './../Reporting.scss';
import GHGDataView from './GHGDataView';
import ReportService from '../../../../core/service/ReportService';
import { LoaderContext } from '../../../../App';
import moment from 'moment';
import CarbonEmissionService from '../../../../core/service/CarbonEmissionService';

const GHGContainer = ({ t }) => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const regulationId = searchParams.get('regulationId') ?? 0;
	const yearParam = searchParams.get('year');
	const yearFilter = yearParam ? +yearParam : currentYear;
	const regulationName = searchParams.get('regulation') ?? null;
	const reportTitle = searchParams.get('title') ?? null;
	const view = searchParams.get('view') ?? null;
	const ghgContentRef = useRef();
	const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const company = lsData.profile.company;
	const { setLoaderDisplay } = useContext(LoaderContext);

	const [page1, setPage1] = useState({});
	const [branchData, setBranchData] = useState({});
	const [countryData, setCountryData] = useState({});
	const [emissionData, setEmissionData] = useState({});

	useEffect(() => {
		fetchReportPages();
	}, []);

	const generatePDF = () => {
		const input = ghgContentRef.current;
		ReportingUtils.downloadBRSRReportPDF(input, `GHG_${yearFilter}.pdf`);
	};

	const generateWord = () => {
		if (!ghgContentRef?.current) return;
		setLoaderDisplay(true);
		ReportingUtils.downloadBRSRReportWord(
			ghgContentRef.current.outerHTML,
			`GHG_${yearFilter}.docx`,
			{ onComplete: () => setLoaderDisplay(false) },
		);
	};

	const saveReport = () => {
		const title = reportTitle ?? `${regulationName} Report - ${moment().format('DD.MM.YYYY hh:mm:ss')}`;
		const payload = [];
		const pData = JSON.parse(JSON.stringify(page1));
		Object.keys(pData)?.forEach(key => {
			const page = pData[key];
			page.keyValues?.forEach(k => {
				delete k.id;
			});
			delete page.id;
			page['title'] = title;
			page['period'] = `${yearFilter}-01-01`;
			payload.push(page);
		});
		setLoaderDisplay(true);
		ReportService.captureReport(payload).then(res => {
			setLoaderDisplay(false);
			gotoGHGList();
		}).catch(err => {
			setLoaderDisplay(false);
		})
	};

	const getPageRequest = (pageId, period) => {
		if (reportTitle === null) {
			return ReportService.getReportTemplate({
				pageId: pageId,
				type: 'GHG',
				standardId: regulationId,
				period: period
			});
		} else {
			return ReportService.getReportTemplateData({
				pageId: pageId,
				standardId: regulationId,
				period: period,
				title: reportTitle,
				type: 'GHG'
			});
		}
	};

	const fetchReportPages = () => {
		setLoaderDisplay(true);
		const page1Req = getPageRequest(1, `${yearFilter}-01-01`);
		const branchReq = CarbonEmissionService.getBranchDataForGHGReport(regulationId, `${yearFilter}-01-01`);
		const countryReq = CarbonEmissionService.getCountryDataForGHGReport(regulationId, `${yearFilter}-01-01`);
		const dataReq = CarbonEmissionService.getEmissionDataForGHGReport(regulationId, `${yearFilter}-01-01`);
		Promise.all([
			page1Req,
			branchReq,
			countryReq,
			dataReq
		]).then(res => {
			const p1Data = {};
			res[0].data.data?.forEach(d => {
				p1Data[d.key] = d;
			});
			setPage1(p1Data);
			setBranchData(res[1].data?.data ?? {});
			setCountryData(res[2].data?.data ?? {});
			setEmissionData(res[3].data?.data ?? {});
			setLoaderDisplay(false);
		}).catch(err => { setLoaderDisplay(false); });
	};

	const gotoGHGList = () => {
		if (view == 'GHG') {
			navigate(`/company_admin/ghg_inventory_report`)
		} else {
			navigate(`/company_admin/reporting_list?view=GHG`)
		}
	}

	return (
		<div className="ETA_card_main GHG_CardMain" >
			<FloatingActionBarForReport
				onGeneratePDF={() => generatePDF()}
				onGenerateWord={() => generateWord()}
				onSave={() => saveReport()}
				onExit={() => gotoGHGList()} />
			<div className='row'>
				<div className='col-md-12'>
					<GHGDataView
						ghgContentRef={ghgContentRef}
						company={company}
						yearFilter={yearFilter}
						page1={page1}
						branchData={branchData}
						countryData={countryData}
						emissionData={emissionData} />
				</div>
			</div>
		</div>);
}

export default withTranslation()(GHGContainer);
